module.exports = __webpack_public_path__ + "static/images/live-goods-tips-arr.4edb9cf.png";